// extracted by mini-css-extract-plugin
export var blue = "_30-f";
export var brand = "_30-b";
export var darkGrey = "_30-e";
export var disabled = "_30-4";
export var disabledSubtle = "_30-5";
export var error = "_30-6";
export var green = "_30-g";
export var grey = "_30-d";
export var icon = "_30-0";
export var inherit = "_30-a";
export var lightGrey = "_30-c";
export var orange = "_30-i";
export var pink = "_30-k";
export var primary = "_30-1";
export var purple = "_30-l";
export var red = "_30-j";
export var secondary = "_30-2";
export var success = "_30-9";
export var tertiary = "_30-3";
export var warning = "_30-7";
export var warningSecondary = "_30-8";
export var white = "_30-m";
export var yellow = "_30-h";